import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getRequest } from 'services/request';

import { APP_THEME } from 'settings/constants';

export const getNotifications = createAsyncThunk(
  `notifications/GET_LIST`,
  async (params: any, { rejectWithValue }) => {
    try {
      const response: any = await getRequest('/api/notifications', {
        params
      });

      return response;
    } catch (error: any) {
      return rejectWithValue(error?.data);
    }
  }
);

export const getUnreadNotifications = createAsyncThunk(
  `notifications/GET_UNREAD_LIST`,
  async (params: any, { rejectWithValue }) => {
    try {
      const response: any = await getRequest('/api/notifications', {
        params
      });

      return response;
    } catch (error: any) {
      return rejectWithValue(error?.data);
    }
  }
);

interface CommonDataInterface {
  listNotifications: any[];
  unreadNotificationsCount: any;
  appTheme: string;
  pedding: boolean;
  total: number;
}

const initialState: CommonDataInterface = {
  listNotifications: [],
  unreadNotificationsCount: 0,
  appTheme: localStorage.getItem(APP_THEME) || 'theme1',
  pedding: false,
  total: 0
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    actionChangeTheme: (state, action: PayloadAction<any>) => {
      state.appTheme = action.payload;
      localStorage.setItem(APP_THEME, action.payload);
    }
  },

  extraReducers: {
    [getNotifications.pending.toString()]: state => {
      state.pedding = true;
    },
    [getNotifications.rejected.toString()]: state => {
      state.pedding = false;
    },
    [getNotifications.fulfilled.toString()]: (state, action) => {
      state.listNotifications = action?.payload?._embedded || [];
      state.pedding = false;
      state.total = action?.payload?._size;
    },

    [getUnreadNotifications.pending.toString()]: state => {
      state.pedding = true;
    },
    [getUnreadNotifications.rejected.toString()]: state => {
      state.pedding = false;
    },
    [getUnreadNotifications.fulfilled.toString()]: (state, action) => {
      state.unreadNotificationsCount = action?.payload?._size;
    }
  }
});

export const { actionChangeTheme } = commonSlice.actions;
export default commonSlice.reducer;
